/**
 * Tutorial guidato delle impostazioni SMTP / IMAP.
 *
 * Un preparativo solo: il riquadro del primo servizio, che il passo dedicato apre
 * per mostrarne i campi. `stopSmtpTour` lo richiude a fine giro, e solo se ad
 * aprirlo e' stato il tutorial. Gli interruttori non si toccano: salvano subito.
 */
const SCOPE = '[data-tour-scope="setting-smtp"]';

const at = name => `${SCOPE} [data-tour="${name}"]`;

let opened = false;

const visible = selector => {
	const element = document.querySelector(selector);

	return !!element && element.getClientRects().length > 0;
};

/** Apre il riquadro del primo servizio, se non e' gia' aperto. */
function openFirst() {
	if (visible(at('settings'))) return;

	const toggle = document.querySelector(at('expand'));

	if (toggle) {
		opened = true;
		toggle.click();
	}
}

/** Richiude il riquadro aperto dal tutorial. */
export function stopSmtpTour() {
	if (!opened) return;

	opened = false;

	if (visible(at('settings'))) {
		document.querySelector(at('expand'))?.click();
	}
}

export function createSmtpTourSteps() {
	return [
		{
			body: "Questa e' la casella di posta con cui il gestionale scrive: SMTP per mandare - conferme d'ordine, avvisi di spedizione, comunicazioni - e IMAP per leggere le risposte che tornano indietro.",
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'La posta del gestionale',
		},
		{
			body: "Due righe, due servizi distinti, ognuno con il suo interruttore che salva subito. SMTP e' quello indispensabile: senza, tutte le mail automatiche restano ferme senza dirlo a nessuno.",
			key: 'table',
			placement: 'top',
			target: at('table'),
			title: 'Invio e ricezione',
		},
		{
			body: "Il piu' a inizio riga apre la configurazione: server, porta, utente e password della casella, quelli che il fornitore di posta indica nelle istruzioni per i programmi di posta. Non e' l'indirizzo pubblico del negozio - quello sta nei dati del negozio - ma la casella tecnica da cui il gestionale spedisce.",
			before: stopSmtpTour,
			key: 'expand',
			placement: 'right',
			target: at('expand'),
			timeout: 400,
			title: 'Aprire la configurazione',
		},
		{
			body: "I campi si compilano con i dati della casella e si confermano qui dentro. Vale la pena mandarsi una mail di prova subito dopo: un errore di porta o di password non si vede da nessuna parte finche' non serve mandare qualcosa a un cliente.",
			before: openFirst,
			key: 'settings',
			placement: 'right',
			target: at('settings'),
			timeout: 600,
			title: 'I dati della casella',
		},
	];
}
